import * as React from "react"
const Globe = () => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={49}
    height={48}
    fill="none"
  >
    <rect width={48} height={48} x={0.5} fill="#E0EEFE" rx={12} />
    <path
      fill="#084784"
      d="m26.121 14.426-.663-.915c-.092-.127-.138-.191-.209-.224-.07-.033-.144-.028-.294-.017a7.714 7.714 0 0 0-4.47 1.823c-.065.055-.026.155.06.16.98.058 1.502.603 2.073 1.207.884.934 1.578.857 1.904.685.133-.07.158-.12.166-.138.027-.055.038-.112.078-.33.033-.18.09-.493.29-.794.21-.318.525-.55.94-.714.173-.069.226-.165.245-.255.024-.113.005-.293-.12-.488Z"
    />
    <path
      fill="#084784"
      d="M27.54 13.915c-.097-.212-.146-.318-.103-.367.043-.049.145-.017.35.046a7.757 7.757 0 0 1 5.463 7.411c0 .14-.115.25-.254.25H32c-.973 0-1.577.416-1.991.702l-.034.023c-.401.276-.542.348-.828.29-1.265-.253-2.279-.29-3.003.046-.395.182-.69.468-.874.839-.175.353-.228.738-.228 1.103 0 .638-.006.824-.043.974-.034.134-.097.256-.376.736-.193.332-.393.776-.371 1.273.024.543.303 1.002.771 1.356a.081.081 0 0 1-.057.144 7.753 7.753 0 0 1-7.216-7.736c0-1.377.359-2.67.988-3.791.121-.216.182-.324.299-.393.117-.068.252-.068.52-.068h.919c.315.022.474.127 1.053.739 1.215 1.285 2.62 1.547 3.694.98.388-.206.65-.476.81-.8.127-.257.174-.527.2-.679l.009-.046c.031-.174.05-.213.064-.235.005-.008.046-.07.242-.148.63-.25 1.034-.746 1.16-1.338.096-.453.02-.903-.167-1.31Z"
    />
    <path
      fill="#084784"
      d="M27.07 28.355c.116.096.173.144.245.16.073.016.142-.003.279-.042a7.77 7.77 0 0 0 5.252-4.991c.107-.317.16-.476.07-.601s-.266-.125-.619-.125H32c-.5 0-.773.184-1.175.46l-.014.01c-.415.286-1.021.704-1.958.516-1.235-.247-1.826-.181-2.08-.064-.095.044-.133.09-.16.145-.036.072-.071.203-.071.435v.087c0 .511 0 .898-.088 1.25-.09.367-.272.678-.496 1.062l-.038.066c-.145.25-.173.387-.17.452.001.021.006.04.02.066.018.03.061.087.166.165a.786.786 0 0 1 .035.028l1.1.921Z"
    />
    <path
      fill="#084784"
      fillRule="evenodd"
      d="M19.217 13.303a1 1 0 0 1-.02 1.414 8.847 8.847 0 0 0-2.697 6.365C16.5 26 20.522 30 25.5 30a9.01 9.01 0 0 0 6.303-2.552 1 1 0 0 1 1.394 1.434A11.01 11.01 0 0 1 25.5 32v1h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1v-1.18c-5.115-.933-9-5.38-9-10.738 0-3.056 1.267-5.82 3.303-7.799a1 1 0 0 1 1.414.02Z"
      clipRule="evenodd"
    />
  </svg>
)
export default Globe
